/* eslint-disable */
if (document.getElementById('butiken')) {
  var VueMasonryPlugin = window["vue-masonry-plugin"].VueMasonryPlugin
  // Trying to 
  Vue.use(VueMasonryPlugin)
  var butikenMasonry = new Vue({
    el: '#butiken',
    data: {
      loading: true,
      wpdata: '',
      pageImages: null,
      previousNum: null,
      pageParagraphs: null,
      postAmount: 5,
      currentCat: 'alla',
      filteredPosts: [],
      pagePostsRaw: [],
      popUp: {
        media: '',
        text: '',
        category: '',
        refnum: '',
        catName: ''
      },
      filterCats: [
        { 
          name: 'Alla',
          slug: 'alla'
        },
        { 
          name: 'Halsband',
          slug: 'halsband'
        },
        { 
          name: 'Vigsel',
          slug: 'vigsel'
        }
      ], 
      idx: 0,
      selected: '',
      all: false,
      imageLoaded: {}
    },
    methods: {
      imageProgress () {
        console.log('Nu har dem laddat klart')
      },
      filterPosts (cat) {
        this.currentCat = cat
        $('.wf-image img').attr('class', 'hidden')
        let beforeFilter = document.getElementById('butiken-info')
        let top = beforeFilter.offsetTop
        top += beforeFilter.scrollHeight
        $('html, body').animate({
          scrollTop: top + 'px'
        }, 400, () => {
          $('.wf-grid:first-child .wf-image img').addClass('fade-in-element').removeClass('hidden')
        })
      },
      openPop (smycke) {
        this.popUp = smycke
      },
      closePop () {
        this.popUp = {
          media: '',
          text: '',
          category: '',
          refnum: '',
          catName: ''
        }
      },
      increaseIndex (cat) {
        this.idx++
        return 'ok'
      },
      scrollDown () {
        this.postAmount += 5
        this.all = false
        if (this.postAmount > this.renderedPosts.length) {
          this.all = true
        }
        this.$redrawVueMasonry()
        /*
        $('html, body').animate({
          scrollTop: window.scrollY + 300+'px'
        }, 800) */
      },
      elementInViewport (el) {
        var top = el.offsetTop
        var left = el.offsetLeft
        var width = el.offsetWidth
        var height = el.offsetHeight
        while(el.offsetParent) {
          el = el.offsetParent
          top += el.offsetTop
          left += el.offsetLeft
        }
        return (
          top >= window.pageYOffset &&
          left >= window.pageXOffset &&
          (top + height) <= (window.pageYOffset + window.innerHeight) &&
          (left + width) <= (window.pageXOffset + window.innerWidth)
        )
      }
    },
    computed: {
      pagePosts () {
        return this.pagePostsRaw.map((a) => {
          let catNames = a._embedded['wp:term'][0].map(b => {
            return b.name
          })
          let imageString = a._embedded['wp:featuredmedia']
          if (typeof imageString !== 'undefined' && typeof a._embedded['wp:featuredmedia'][0]['media_details'].sizes.large !== 'undefined') {
            imageString = a._embedded['wp:featuredmedia'][0]['media_details'].sizes.large.source_url
          } else {
            imageString = 'none'
          }
          return {
            media: imageString,
            text: a.content.rendered,
            category: a.categories[0],
            catName: catNames,
            postId: a.id
          }
        }).filter((a) => {
          return a.media !== 'none'
        })
      },
      categories () {
        //  console.log('page-post: ', this.pagePosts)
        let cats = this.pagePostsRaw.map((a) => {
          return a._embedded['wp:term'][0]
        })
        let uniq = []
        for (let i = 0; i < cats.length; i++) {
          for (let j = 0; j < cats[i].length; j++) {
            if (uniq.indexOf(cats[i][j].name.toLowerCase()) === -1) {
              uniq.push(cats[i][j].name.toLowerCase())
            }
          }
        }
        uniq.push('alla')
        return uniq.sort()
      },
      renderedPosts () {
        let self = this
        if (this.currentCat === 'alla') {
          return this.pagePosts
        }
        return this.pagePosts.filter((a) => {
          let hasCat = false
          a.catName.forEach(b => {
            if (b.toLowerCase() === self.currentCat.toLowerCase()) {
              hasCat = true
            }
          })
          return hasCat
        })
      }
    },
    beforeMount () {
      var self = this
      if (document.getElementById('vigsel-hidden')) {
        this.currentCat = 'vigsel'
      }
      fetch(window.ApiUrl + 'wp/v2/posts?_embed=true&per_page=300')
        .then(function(response) {
          return response.json()
        })
        .then(function(myJson) {
          self.wpdata = myJson
          self.pagePostsRaw = myJson
          self.loading = false
          //  console.log(self.pagePostsRaw)
        })
    },
    updated () {
      //  Code that will run only after the
      //  entire view has been re-rendered


    },
    watch: {
      renderedPosts () {
        // Check when images loaded
        let self = this
        this.imageLoaded = window.imagesLoaded('stream')
        this.imageLoaded.on('always', () => {
          self.$redrawVueMasonry()
          window.setTimeout(() => {
            self.$redrawVueMasonry()
          }, 1200)
        })
      }
    },
    mounted () {
      let self = this;
      var animateHTML = function () {
        var elems, windowHeight
        var init = function () {
          elems = document.getElementsByClassName('hidden')
          windowHeight = window.innerHeight
          _addEventHandlers()
        }
        var _addEventHandlers = function () {
          window.addEventListener('scroll', _checkPosition)
          window.addEventListener('resize', init)
        }
        var _checkPosition = function (e) {
          let element = e.target
          let loadButt = document.getElementById('load-button')
          if (loadButt) {
            let buttToTop = loadButt.getBoundingClientRect().top
            if (buttToTop <= window.innerHeight + 80) {
              self.scrollDown()
            }
          }
          /*
          let loadButt = document.getElementById('load-button')
          if (loadButt) {
            self.scrollDown()
          }          
          for (var i = 0; i < elems.length; i++) {
            var posFromTop = elems[i].getBoundingClientRect().top
            if (posFromTop - windowHeight <= 0) {
              elems[i].className = elems[i].className.replace('hidden', 'fade-in-element')
            }
          }
          */
        }
        return {
          init: init
        }
      }
      animateHTML().init()
    }
  })
}
